import { Component, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarClienteTiposComponent } from 'src/app/views/shared/modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component';
import { ModalAddeditPromocionComponent } from './modal-addedit-promocion.component';
import gql from 'graphql-tag';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, filter } from 'rxjs/operators';
import { DatesService } from 'src/app/shared/services/dates.service';
import { ModalShowClientesComponent } from '../modal-show-clientes/modal-show-clientes.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.scss'],
  providers: [SecurityService],
})
export class PromocionesComponent implements OnInit, OnDestroy {

  // Inputs
  @Input() optionsTipoDescuento: any = []
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = []
  @Input() permiteUnidadNegocio: any = []


  // Modales
  @ViewChild(ModalAddeditPromocionComponent, { static: true }) agregarPromocionModal: ModalAddeditPromocionComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent

  // Form
  formData: FormGroup

  // Constants
  readonly TIPO_CLIENTE: String = `_CLIENTE_`
  readonly TIPO_TIPO_CLIENTE: String = `_TIPO_CLIENTE_`

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  listaPromociones: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false
  // clienteSeleccionado: any = null
  clientesSeleccionados: Array<any> = null
  clientesSeleccionadosFormatted: String = null
  tiposClientesSeleccionados: any = null
  tiposClientesSeleccionadosFormatted: String = null


      // check Estado promociones
      readonly RO_EstadoActivoProm: boolean = true
      readonly RO_EstadoInactivoProm: boolean = false

  // Utils
  private log: any
  private subs = new Subscription()

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('PROMOCIONES')
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa()
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo()
    this.paginationContext.RecordsByPage = 10
    this.createForms()
    this.formChangesSubscriptions()
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
  }

  trackByPromocionCodigo(index: number, item: any) {
    return item && item.codigo != null ? item.codigo : index
  }

  /********* FORMS *********/
  createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      buscarPor: [this.TIPO_CLIENTE, [Validators.required]],
      fechaInicio: [initDate],
      fechaFin: [currentDate],
      rutCliente: [''],
      estadoActProm: [this.RO_EstadoActivoProm]
    });
  }

  private formChangesSubscriptions() {
    this.subs.add(
      this.formData.get("rutCliente").valueChanges
        .pipe(filter(Boolean), debounceTime(1000))
        .subscribe((rutCliente: string) => {
          this.modalSeleccionarCliente.searchByRut(rutCliente)
        })
    )
    this.subs.add(
      this.formData.get("buscarPor").valueChanges.subscribe(buscarPor => {
        this.log('change ', buscarPor)
        this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside()
      })
    )
  }
  /********* FORMS *********/

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.clientesSeleccionadosFormatted = null
  }

  limpiarBuscarPorTiposClientes() {
    this.tiposClientesSeleccionados = null
    this.tiposClientesSeleccionadosFormatted = null
    this.modalSeleccionarCliente.cleanLast()
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.tiposClientesSeleccionados = null
  }

  abrirModalSeleccion() {
    if (this.formData.get('buscarPor').value === this.TIPO_CLIENTE)
      this.abrirModalSeleccionarCliente()
    else if (this.formData.get('buscarPor').value === this.TIPO_TIPO_CLIENTE)
      this.abrirModalSeleccionarClientesTipos()
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected()
  }

  abrirModalSeleccionarTiposClienteSeleccionados() {
    this.modalSeleccionarClientesTipos.showSelected()
  }

  abrirModalSeleccionarClientesTipos() {
    this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados)
  }

  // onClienteSeleccionado({ data, origen }) {
  //   this.log(origen, data)
  //   this.limpiarDataSeleccionada()
  //   this.clienteSeleccionado = data
  // }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.log(origen, data)
    this.limpiarDataSeleccionada()
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')
  }

  onClienteSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada()
    this.formData.get('rutCliente').setValue('')
    this.clientesSeleccionados = [data]
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')
  }

  onClienteTiposSeleccionado({ data, origen }) {
    this.log(origen, data)
    this.limpiarDataSeleccionada()
    this.tiposClientesSeleccionados = data
    // this.log('seleccionados', data)
    // this.log('this.tiposClientesSeleccionados', this.tiposClientesSeleccionados)
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.descripcion).join(', ')
    this.log('onClienteTiposSeleccionado this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted)
  }

  onClienteTiposSeleccionadoMain({ data, origen }) {
    this.log('onClienteTiposSeleccionadoMain', origen, data)
    this.limpiarDataSeleccionada()
    this.tiposClientesSeleccionados = data
    this.log('onClienteTiposSeleccionadoMain seleccionados', data)
    // this.log('this.tiposClientesSeleccionados', this.tiposClientesSeleccionados)
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.descripcion).join(', ')
    // this.log('this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted)
  }

  onClienteTiposSeleccionadoModal({ data, origen }) {
    this.log('onClienteTiposSeleccionadoModal', origen, data)
    this.limpiarDataSeleccionada()
    this.tiposClientesSeleccionados = data
    this.log('onClienteTiposSeleccionadoModal seleccionados', data)
    // this.log('this.tiposClientesSeleccionados', this.tiposClientesSeleccionados)
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.codigo).join(', ')
    // this.log('this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted)
  }

  abrirModalAgregarPromocion() {
    this.agregarPromocionModal.show('ADD')
  }
  /********* MODALS *********/

  /********* OPERATIONS *********/
  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1
    this.log(this.formData.value)

    const esTipoCliente = this.formData.get("buscarPor").value === this.TIPO_TIPO_CLIENTE

    const _variables = {
      rut_empresa: Number(this.rutEmpresa),
      sucursal_codigo: Number(this.sucursalEmpresa),
      fecha_inicio: this.formData.get('fechaInicio').value || '0001-01-01',
      fecha_termino: this.formData.get('fechaFin').value || '0001-01-01',
      activo: this.formData.get('estadoActProm').value,
      tipo_cliente: [],
      rut_cliente_multiple: [],
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    if (esTipoCliente && this.tiposClientesSeleccionados) {
      _variables.tipo_cliente = this.tiposClientesSeleccionados.map(tipo => ({ codigo: tipo.codigo }))
    }
    else if (this.clientesSeleccionados) {
      _variables.rut_cliente_multiple = this.clientesSeleccionados.map(cliente => ({ rut: cliente.rut }))
    }

    // this.log(_variables, this.clientesSeleccionados, this.tiposClientesSeleccionados)
    this.log('variables', JSON.stringify(_variables))

    this.loaded = false
    this.loading = true
    this.listaPromociones = []

    const self = this
    this.gqlclient.query(
      {
        query: gql`
          query
          (
            $rut_empresa: Decimal,
            $sucursal_codigo: Decimal,
            $fecha_inicio: Date,
            $fecha_termino: Date,
            $tipo_cliente: [tipo_clienteInputType],
            $rut_cliente_multiple: [cliente_proveedorInputType],
            $activo: Boolean
            $paginaActual: Int,
            $cantidadRegistrosPorPagina: Int
          )
          {
            promocion{
              obtenerSegunFiltro
              (
                filtro:{
                  exacto:{
                    rut_empresa: $rut_empresa
                    sucursal_codigo: $sucursal_codigo
                    codigo: -1
                    fecha_inicio: $fecha_inicio
                    fecha_termino: $fecha_termino
                    activo: $activo
                    tipo_cliente: $tipo_cliente
                    rut_cliente_multiple: $rut_cliente_multiple
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              )
              {
                mensajes{
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros{
                    codigo
                    sucursal_codigo
                    rut_empresa
                    fecha_termino
                    fecha_inicio
                    activo
                    unidad_negocio_codigo
                    permiteEdicion
                  }
                }
              }
            }
          }
         `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        self.log(response)
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes, respuesta } = response.data.promocion.obtenerSegunFiltro
        self.log(respuesta)
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        self.paginationContext.RecordsCount = totalRegistros
        self.paginationContext.CurrentPage = paginaActual
        self.paginationContext.PagesCount = totalPaginas
        self.log(self.paginationContext)
        self.listaPromociones = registros
        self.loaded = true
        self.loading = false
      }
    );
  }

  onPromocionSaved() {
    this.log('onPromocionSaved')
    this.buscar(true)
  }

  ver({ rut_empresa, sucursal_codigo, codigo }) {
    this.agregarPromocionModal.load(rut_empresa, sucursal_codigo, codigo, false)
  }

  editar({ rut_empresa, sucursal_codigo, codigo }) {
    this.agregarPromocionModal.load(rut_empresa, sucursal_codigo, codigo, true)
  }

  confirmDesactivar(codigo: number) {
    this.modalConfirm.show(() => { this.desactivar(codigo) })
  }

  desactivar(codigo: number) {
    const promo = {
      rut_empresa: Number(this.rutEmpresa),
      sucursal_codigo: Number(this.sucursalEmpresa),
      codigo,
      activo: false
    }

    const self = this
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation($entidad: promocionInputType) {
            promocion {
              cambiarEstado(entidad: $entidad) {
                mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  codigo
                  sucursal_codigo
                  rut_empresa
                  fecha_inicio
                  fecha_termino
                  activo
                }
              }
            }
          }
        `,
        variables: {
          entidad: promo
        },
      },
      function (_respuesta) {
        self.log(_respuesta)
        const { mensajes, respuesta } = _respuesta.data.promocion.cambiarEstado
        const ok = respuesta !== null
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          return
        }
        else {
          self.toastrService.success('Promoción desactivada con éxito')
          self.buscar(true)
        }
        // if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
        //   alert('Registro grabado');
        //   self.editarModalDtoComercielas.hide();
        // } else {
        //   alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
        // }
      }
    );
  }
  /********* OPERATIONS *********/

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados)
  }

}
